// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__1wBtZ","Form":"Sidebar_Form__2QkT3","News":"Sidebar_News__26S9Z"};